var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarOutlinedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.39 16.667c.185 0 .553.184.736.367l3.31 4.598c.185.184.553.368.736.368.184 0 .368-.184.368-.184.184 0 .184-.184.184-.368l1.655-5.517c0-.368.184-.552.552-.552l5.517-1.655c.184 0 .368-.368.552-.552 0-.184 0-.551-.368-.735l-4.598-3.31c-.183-.184-.367-.368-.367-.736V2.69c0-.184-.184-.552-.368-.552-.368-.184-.552-.184-.736 0l-4.598 3.494c-.183.184-.551.184-.735 0L4.713 3.793c-.184 0-.552 0-.736.184-.184.184-.184.552-.184.736l1.84 5.517c.183.184 0 .552-.185.736l-3.31 4.597c-.184.184-.184.552 0 .736.184.184.368.368.552.368h5.7v0z",
    stroke: "#1253FA",
    strokeWidth: 3
  })));
}
export default SvgStarOutlinedIcon;